import type { GlobEnvConfig } from '/#/config'

import { warn } from '/@/utils/log'
import pkg from '../../package.json'
import { getConfigFileName } from '../../build/getConfigFileName'

export function getCommonStoragePrefix() {
    const { VITE_GLOB_APP_SHORT_NAME } = getAppEnvConfig()
    return `${VITE_GLOB_APP_SHORT_NAME}__${getEnv()}`.toUpperCase()
}

// Generate cache key according to version
export function getStorageShortName() {
    return `${getCommonStoragePrefix()}${`__${pkg.version}`}__`.toUpperCase()
}

export function getAppEnvConfig() {
    const ENV_NAME = getConfigFileName(import.meta.env)

    const ENV = (import.meta.env.DEV
        ? // Get the global configuration (the configuration will be extracted independently when packaging)
          (import.meta.env as unknown as GlobEnvConfig)
        : window[ENV_NAME as any]) as unknown as GlobEnvConfig

    const {
        VITE_GLOB_APP_TITLE,
        VITE_GLOB_API_URL,
        VITE_GLOB_APP_SHORT_NAME,
        VITE_GLOB_API_URL_PREFIX,
        VITE_GLOB_UPLOAD_URL,
    } = ENV

    if (!/^[a-zA-Z\_]*$/.test(VITE_GLOB_APP_SHORT_NAME)) {
        warn(
            `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`,
        )
    }

    return {
        VITE_GLOB_APP_TITLE,
        VITE_GLOB_API_URL,
        VITE_GLOB_APP_SHORT_NAME,
        VITE_GLOB_API_URL_PREFIX,
        VITE_GLOB_UPLOAD_URL,
    }
}

/**
 * @description: Development mode
 */
export const devMode = 'development'

/**
 * @description: Production mode
 */
export const prodMode = 'production'

/**
 * @description: Get environment variables
 * @returns:
 * @example:
 */
export function getEnv(): string {
    return import.meta.env.MODE
}

/**
 * @description: Is it a development mode
 * @returns:
 * @example:
 */
export function isDevMode(): boolean {
    return import.meta.env.DEV
}

/**
 * @description: Is it a production mode
 * @returns:
 * @example:
 */
export function isProdMode(): boolean {
    return import.meta.env.PROD
}

/**
 * 获取运行环境中文标识
 * @returns
 */
export function getEnvText(): string {
    switch (import.meta.env.MODE) {
        case 'test':
        case 'alpha':
        case 'beta':
            return '测试版'
        case 'preview':
            return '预览版'
        case 'production':
            return '正式版'
        case 'development':
        default:
            return '开发版'
    }
}
